module.exports = __webpack_public_path__ + "static/media/bart.3b42ed07.jpg";